export default __webpack_public_path__ + "static/media/GQ.e25c9b70.svg";